const dataExample = [
  {
    id: 'AD',
    burger: 192,
    sandwich: 99,
    kebab: 168,
  },
  {
    id: 'AE',
    burger: 194,
    sandwich: 96,
    kebab: 113,
  },
  {
    id: 'AF',
    burger: 189,
    sandwich: 80,
    kebab: 130,
  },
];

export default dataExample;
